{
  "notificationPage": {
    "conflict": {
      "resolvedCi": "Resolved CI",
      "attributes": "Attributes",
      "deletedCis": "CI delete list",
      "createdLinks": "Created link list",
      "deletedLinks": "Deleted link list"
    }
  },
  "notificationView": {
    "badFormat": "Incorrect notification format",
    "table": {
      "created_at": "Time",
      "body": "Message"
    }
  }
}